import { AbstractControl } from '@angular/forms';

export enum FormStatus {
  INITIAL,
  LOADING,
  COMPLETE,
  ERROR,
  INITIALIZING,
  INITIALIZING_ERROR,
}

export enum AnalyticsFormStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  SEND_ATTEMPT = 'send-attempt',
}

export enum ReactiveFormStatus {
  INVALID = 'INVALID',
}

export enum FormInputType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  SELECT = 'select',
}

export interface CheckboxOption {
  label: string;
  id: string;
}

export type CheckboxOptionList = CheckboxOption[];

export type FormValue<T extends AbstractControl> = T extends AbstractControl<infer TValue, any> ? TValue : never;
export type FormRawValue<T extends AbstractControl> = T extends AbstractControl<any, infer TRawValue>
  ? TRawValue
  : never;
